module.exports = __webpack_public_path__ + "img/Sighet_Dunkelzelle_2kl.ea224d03.jpg";